module.exports = __webpack_public_path__ + "img/cloud-logo.b87c11a8.svg";